import {Component, OnInit, ViewChild, AfterViewInit, Inject} from '@angular/core';
import { FormControl } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatStepper} from '@angular/material';
import { WorkfloweditorComponent} from "./workfloweditor/workfloweditor.component";
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

@Component({
    selector: 'app-bpmn',
    templateUrl: './bpmn.component.html',
    styleUrls: ['./bpmn.component.scss'],
})
export class BpmnComponent implements AfterViewInit, OnInit {
    selected = new FormControl(0);
    title = 'Workflow Modeler';
    isExecute: boolean;
    isDesigner: boolean;
    dataType = ['String',
        'Integer',
        'Date',
        'Double',
        'Timestamp',
        'Boolean',
        'Array',
        'Array Of Strings',
        'Object',
        'ObjectId'
    ];
    variables = [];
    // @Output() bpmnVariables = [];
    bpmnVariables = [];
    deploymentName : any;
    xmlData: any;
    deploymentSource : any;
    showNextPanel: boolean;
    constructor(public platform: LeftpanelComponent, public dialog: MatDialog) {
    }
    @ViewChild('stepper') stepper: MatStepper;
    @ViewChild(WorkfloweditorComponent) workfloweditor: WorkfloweditorComponent;
    ngAfterViewInit(): void {
        this.variables.push({variableName: '', variableType: '', variableValue:''});
        this.showNextPanel = this.workfloweditor.showNextPanel;
    }
    ngOnInit() {
        this.isDesigner = true;
    }
    designer() {
        this.isDesigner = true;
    }
    output() {
        this.isDesigner = false;
    }
    processFile(imageInput: any) {
        this.workfloweditor.processFile(imageInput);
    //     const file: File = imageInput.files[0];
    //     const reader = new FileReader();
    //     // this.modeler.importXML(file, value => this.handleError(value));
    //     reader.addEventListener('load', (event: any) => {
    //
    //         this.selectedFile = new ImageSnippet(event.target.result, file);
    //         this.load(this.selectedFile['src']);
    //         this.confPost.uploadS3FileForBPMN(localStorage.getItem('account'), '', localStorage.getItem('partner'), this.selectedFile.file, '').subscribe(
    //             (res) => {
    //                 this.platform.openSnackBar('Uploaded Successfully!', 'Success', {
    //                     duration: 2000,
    //                     verticalPosition: 'top',
    //                     horizontalPosition: 'center'
    //                 });
    //
    //                 // this.modeler.importXML(this.selectedFile.file, value => this.handleError(value));
    //                 // this.load(this.selectedFile.file);
    //             },
    //             (err) => {
    //                 this.platform.openSnackBar('Error occured while upload, Please try after sometime', 'Error', {
    //                     duration: 2000,
    //                     verticalPosition: 'top',
    //                     horizontalPosition: 'center'
    //                 });
    //             });
    //     });
    //     reader.readAsDataURL(file);
    }
    execute() {
        const that = this;
        this.workfloweditor.execute();//modeler.saveXML({ format: true }, function(err, xml) {
            //that.xmlData = xml;
            // const dialogRef = that.dialog.open(VariablesDialog, {
            //     width: '1050px',
            //     data: that.variables
            // });
            that.bpmnVariables = [''];
            that.variables = [''];
            that.deploymentName = that.workfloweditor.executor_name + '_' + that.workfloweditor.selectedVersion;
            that.deploymentSource = that.workfloweditor.executor_name + '_' + that.workfloweditor.selectedVersion;
            that.isExecute = true;
            that.selected.setValue(1);
            that.isDesigner = false;
            // dialogRef.afterClosed().subscribe(result => {
            //     if (dialogRef.componentInstance.deploymentName !== "" && dialogRef.componentInstance.deploymentSource !== "" && dialogRef.componentInstance.deploymentName !== undefined && dialogRef.componentInstance.deploymentSource !== undefined ){
            //         that.bpmnVariables = dialogRef.componentInstance.data;
            //         that.variables = dialogRef.componentInstance.data;
            //         that.deploymentName  =  dialogRef.componentInstance.deploymentName;
            //         that.deploymentSource = dialogRef.componentInstance.deploymentSource;
            //         that.isExecute = true;
            //         that.selected.setValue(1);
            //         // this.workfloweditor.modeler.saveXML({ format: true }, function(err, xml) {
            //         //     // log the current xml content to the browser console
            //         // });
            //         // this.animal = result;
            //     } else{
            //         that.snackBar.open('Please fill out Deployment Name and Source to execute the model', 'Error', {
            //             duration: 2000,
            //             verticalPosition: 'top',
            //             horizontalPosition: 'center'
            //         });
            //     }
            //
            // });
        //});


    }

}
@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: 'variablesDialog.html',
})
export class VariablesDialog {
    deploymentName: any;
    deploymentSource: any;
    constructor(
        public dialogRef: MatDialogRef<VariablesDialog>,
        @Inject(MAT_DIALOG_DATA) public data: [{variableName: '', variableType: '', variableValue:''}] ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }
    addNew() {
        this.data.push({variableName: '', variableType: '', variableValue:''});

    }
    removeNew(index){
        // this.extracedDataForResume.splice(index, 1);
        this.data.splice(index, 1);
    }
}
